module.exports = __webpack_public_path__ + "img/The_Digital_Upgrade_to_Paper-Based_Trade.42b57cd1.jpg";